import Promotion from './Promotion'
import Detail from './Detail'
export default {
  Promotion, Detail
}



// WEBPACK FOOTER //
// ./src/components/Promotion/index.js